/**
 * Raw mutation service fn for project file review/approval.
 *
 * Relocated from `features/projects/api/projectFiles.api.ts` under
 * The matching read services + queryOptions
 * Helpers live canonically in `entities/project-file` since.
 *
 * `updateProjectFileStatus` belongs to this slice (rather than
 * features/upload-project-file) because file-status changes are part of
 * the review/approval workflow that runs AFTER upload — different lifecycle,
 * different consumers, different cache shape (the status mutation has to
 * invalidate folder approval-progress aggregations, the upload mutation
 * does not).
 */
import {
  type ProjectFileResponseDto,
  ProjectFilesService,
  type UpdateFileStatusDto,
} from '@inference.engine/workspace-api-client/web';
import { workspaceHttp } from '@/lib/api/http-client';

export const updateProjectFileStatus = async (
  platformProjectId: string,
  fileId: string,
  data: UpdateFileStatusDto,
): Promise<ProjectFileResponseDto> => {
  const response = await ProjectFilesService.updateFileStatus({
    client: workspaceHttp,
    path: { platformProjectId, fileId },
    body: data,
  });

  if (!response.data) {
    throw new Error('Failed to update file status');
  }

  return response.data;
};
